// Los filtros de fecha vienen del núcleo único, compartido con mrtFilterService.
// Antes esta traducción estaba duplicada acá y derivó (usaba lte donde el otro
// usaba lt). Una sola fuente para la lógica riesgosa.
import {
  dayFilter,
  yearFilter,
  yearMonthFilter,
  fromToFilter,
  calendarDayFilter,
  calendarYearFilter,
  calendarYearMonthFilter,
  calendarFromToFilter,
} from "../../../common/services/dateFilterCore";
import { GridFilter } from "../types";

export const filterValues2Expression = (
  columnName: string,
  columnType: string,
  operation: string,
  value: any,
  timeZone: string,
  subFilters: Record<
    string,
    { subFields: string[]; multi: boolean } | undefined
  >
) => {
  if (columnType === "Int") {
    value = parseInt(value, 10);
  }
  // Un date (día de calendario, "AAAA-MM-DD"): sin zona ni hora, con el texto del día.
  if (columnType === "Date") {
    switch (operation) {
      case "day":
        return calendarDayFilter(columnName, value);
      case "year":
        return calendarYearFilter(columnName, value);
      case "year-month":
        return calendarYearMonthFilter(columnName, value);
      case "from-to":
        return calendarFromToFilter(columnName, value);
    }
  }

  const filterOthers = (operator: string) => {
    const filterSubFields = subFilters[columnName];
    const op = operator === "equals-Str" ? "equals" : operator;
    const mode = op === "equals" ? {} : { mode: "insensitive" };
    if (filterSubFields) {
      const subFiltersExpression = filterSubFields.subFields.map((x) => {
        const fieldPath = x.split(".");
        let filterObject = { [op]: value, ...mode };
        for (let index = fieldPath.length - 1; index >= 0; index--) {
          filterObject = { [fieldPath[index]]: filterObject };
        }
        return filterObject;
      });
      if (subFiltersExpression.length > 1) {
        const expressions: any[] = [];
        for (const expr of subFiltersExpression) {
          expressions.push(expr);
        }
        if (filterSubFields.multi) {
          return { [columnName]: { some: { OR: expressions } } };
        }
        return { [columnName]: { OR: expressions } };
      }
      if (filterSubFields.multi) {
        return { [columnName]: { some: subFiltersExpression[0] } };
      }
      return { [columnName]: subFiltersExpression[0] };
    }
    const fieldPath = columnName.split(".");
    let filterObject = { [op]: value, ...mode };
    for (let index = fieldPath.length - 1; index >= 0; index--) {
      filterObject = { [fieldPath[index]]: filterObject };
    }
    return filterObject;
  };

  switch (operation) {
    case "contains":
      return filterOthers("contains");
    case "startsWith":
      return filterOthers("startsWith");
    case "endsWith":
      return filterOthers("endsWith");
    case "notContains":
      return { NOT: filterOthers("contains") };
    case "equalStr":
      return filterOthers("equals-Str");
    case "notEqualStr":
      return { NOT: filterOthers("equals-Str") };
    case "equal":
      return filterOthers("equals");
    case "notEqual":
      return { NOT: filterOthers("equals") };
    case "lessThan":
      return { [columnName]: { lt: value } };
    case "lessThanOrEqual":
      return { [columnName]: { lte: value } };
    case "greaterThan":
      return { [columnName]: { gt: value } };
    case "greaterThanOrEqual":
      return { [columnName]: { gte: value } };
    case "day":
      return dayFilter(columnName, value, timeZone);
    case "year":
      return yearFilter(columnName, value, timeZone);
    case "year-month":
      return yearMonthFilter(columnName, value, timeZone);
    case "from-to":
      return fromToFilter(columnName, value, timeZone);
    case "empty":
      return { [columnName]: { equals: null } };
    case "notEmpty":
      return { [columnName]: { not: null } };
    case "yes":
      return { [columnName]: { equals: true } };
    case "no":
      return { [columnName]: { equals: false } };
    case "all":
      return undefined;
    default:
      return null;
  }
};
export const getConditionsFromFilters = (
  selectedFilters: GridFilter[],
  columnTypes: Record<string, string>,
  getFilter: (
    fieldName: string,
    columnType: string,
    operator: string,
    value: string
  ) => any
) => {
  const parsedFilters = [];
  for (const filter of selectedFilters) {
    const parsed = getFilter(
      filter.columnName,
      columnTypes[filter.columnName],
      filter.operation || "equals",
      filter.value
    );
    if (parsed && !(Array.isArray(parsed) && parsed.length === 0)) {
      parsedFilters.push(parsed);
    }
  }
  if (parsedFilters.length > 0) {
    return parsedFilters;
  }
  return undefined;
};
